








































import { SfSteps } from '@storefront-ui/vue';
import {
  computed,
  defineComponent,
  ref,
  useRoute,
  useRouter,
  useContext,
  onMounted,
  useFetch
} from '@nuxtjs/composition-api';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import useCart from '~/modules/checkout/composables/useCart';
import CartPreview from '~/modules/checkout/components/CartPreview.vue';
import CircleGradient from '~/components/Headless/Watermarks/CircleGradient.vue';
import HomeWatermark from '~/components/Headless/Watermarks/HomeWatermark.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'CheckoutPage',
  components: {
    SfSteps,
    CartPreview,
    HomeWatermark,
    CircleGradient,
    SkeletonLoader
  },
  setup() {
    const route = useRoute();
    const { app, $strapi } = useContext();
    const { path } = route.value;
    const router = useRouter();
    const { cart, load } = useCart();
    const products = computed(() => cartGetters.getItems(cart.value));
    const currentStep = computed(() => path.split('/').pop());

    const STEPS = ref([
      {
        title: 'User Account',
        url: 'user-account',
      },
      {
        title: 'Recipient Details',
        url: 'shipping',
      },
      {
        title: 'Billing',
        url: 'billing',
      },
      {
        title: 'Payment',
        url: 'payment',
      },
    ]);

    const currentStepIndex = computed(() => STEPS.value.findIndex((step) => step.url === currentStep.value));
    const isThankYou = computed(() => currentStep.value === 'thank-you');

    const handleStepClick = async (stepIndex: number) => {
      if (stepIndex <= currentStepIndex.value) {
        const { url } = STEPS.value[stepIndex];
        await router.push(`${app.localePath(`/checkout/${url}`)}`);
      }
    };

    onMounted(async () => {
      await load();
      if (products.value.length === 0 && currentStep.value !== 'thank-you') {
        await router.push(app.localePath('/'));
      }
    });

    // Fetch Strapi checkout charactistics data
    const qs = require('qs');
    const query = qs.stringify({
      populate: [
        'characteristic'
      ],
    }, {
      encodeValuesOnly: true, // prettify URL
    });

    // Get Strapi Data
    const strapiData = ref<Object>({});
    useFetch(async () => {
      strapiData.value = await $strapi.find('checkout-characteristic?' + query);
    });

    return {
      handleStepClick,
      STEPS,
      currentStepIndex,
      isThankYou,
      currentStep,
      strapiData
    };
  },
  head() {
    return {
      script: [
        {
          src: 'https://js.stripe.com/v3'
        }
      ],
    }
  }
});
